export default "__VITE_ASSET__csaQrreu__"